import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import { IUser } from '../../UserSlice';
import { RootState } from '../..';
import {
  adminCreateManualAdjustment,
  adminGetManualAdjustments,
} from './adminApi';

export interface IManualAdjustment {
  _id: string;
  tutor: string | IUser;
  date: string;
  title: string;
  description: string;
  amount: number;
  currency: string;
  isPaid: boolean;
  createdBy: string | IUser;
  updatedBy: string | IUser;
  createdAt: string;
  updatedAt: string;
}

export interface IInitialManualAdjustmentsState {
  status: 'idle' | 'loading' | 'rejected';
  // Admin
  adminManualAdjustmentListData?: {
    limit?: number;
    offset?: number;
    totalDocs?: number;
    list: Array<IManualAdjustment>;
  };
}

const initialState: IInitialManualAdjustmentsState = {
  status: 'idle',
  // Admin
  adminManualAdjustmentListData: undefined,
};

export const ManualAdjustmentsSlice = createSlice({
  name: 'manualAdjustments',
  initialState,
  reducers: {
    // Admin
    resetAdminManualAdjustmentListData: (state) => {
      state.adminManualAdjustmentListData = undefined;
    },
  },
  extraReducers: (builder) => {
    // Admin
    builder
      .addCase(adminGetManualAdjustments.fulfilled, (state, action) => {
        const result = action.payload;

        const newAdminManualAdjustmentListData = {
          limit: result.limit,
          offset: result.offset,
          totalDocs: result.totalDocs || 0,
          list: result.docs || [],
        };

        state.adminManualAdjustmentListData = newAdminManualAdjustmentListData;
      })
      .addCase(adminCreateManualAdjustment.fulfilled, (state, action) => {
        const result = action.payload;

        if (state.adminManualAdjustmentListData) {
          const newAdminManualAdjustmentListData = {
            ...state.adminManualAdjustmentListData,
          };

          newAdminManualAdjustmentListData.list.unshift(result);

          if (newAdminManualAdjustmentListData.totalDocs) {
            newAdminManualAdjustmentListData.totalDocs += 1;
          } else {
            newAdminManualAdjustmentListData.totalDocs = 1;
          }

          state.adminManualAdjustmentListData = newAdminManualAdjustmentListData;
        }
      });

    // COMMON MATCHERS
    builder.addMatcher(
      isFulfilled(
        // Admin
        adminCreateManualAdjustment,
        adminGetManualAdjustments
      ),
      (state, action) => {
        state.status = 'idle';
      }
    );

    builder.addMatcher(
      isPending(
        // Admin
        adminCreateManualAdjustment,
        adminGetManualAdjustments
      ),
      (state, action) => {
        state.status = 'loading';
      }
    );

    builder.addMatcher(
      isRejected(
        // Admin
        adminCreateManualAdjustment,
        adminGetManualAdjustments
      ),
      (state, action) => {
        state.status = 'rejected';
      }
    );
  },
});

export const getManualAdjustmentsState = (
  state: RootState
): RootState['manualAdjustments'] => state.manualAdjustments;

export const {
  resetAdminManualAdjustmentListData,
} = ManualAdjustmentsSlice.actions;

export * from './adminApi';
export default ManualAdjustmentsSlice.reducer;
